import { useState } from "react";
import { useGetStorefrontList } from "../../../../../hooks/api/queries";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";

export const useAllStorefront = () => {
  const { search, queries, gotoPage, filterBySearch } = useUrlSearch();
  const [showAllStorefontsLink, setShowAllStorefontsLink] = useState(false);
  const { data, isLoading } = useGetStorefrontList({ queries });

  return {
    search,
    isLoading,
    storefrontList: data?.data || [],
    metaDetails: data?.meta || {},
    showAllStorefontsLink,
    setShowAllStorefontsLink,
    gotoPage,
    filterBySearch,
  };
};
